import React from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from 'reactstrap';
import { i18nLanguageKey } from '../i18n';

interface LanguageOption {
    nativeName: string
}

const languages: { [key: string]: LanguageOption } = {
    'en-US': { nativeName: 'English (US)' },
    'sv': { nativeName: 'Svenska' }
};

const LanguageSwitch: React.FC = () => {
    const { t, i18n } = useTranslation(['common']);

    const onChangeHandler: React.ChangeEventHandler<HTMLInputElement> = (event) => {
        var selectedLanguage = event.target.value;
        if (selectedLanguage === 'default') {
            window.localStorage.removeItem(i18nLanguageKey);
            i18n.changeLanguage();
        } else {
            window.localStorage.setItem(i18nLanguageKey, selectedLanguage);
            i18n.changeLanguage(selectedLanguage);
        }
    };

    var selected = Object.keys(languages).find(l => l === i18n.language) ?? 'default';
    return (<Input type="select" value={selected} onChange={onChangeHandler} className="select-input language_selector sm">
        <option key="default" value="default">{t('systemLang', { ns: 'common' })}</option>
        {Object.keys(languages).map((l) => (<option key={l} value={l}>{languages[l].nativeName}</option>))}
    </Input>);
}

export default LanguageSwitch;